module.exports = __webpack_public_path__ + "images/gradients/gradient-alien.ae0ebbdbbc41ef1edd58.svg";